module.exports = __webpack_public_path__ + "img/knu_gallery15.fed7efe9.jpg";